import React from "react";

import { ReactComponent as MedicalAdviceIcon } from "../../../assets/images/icons/medical-advice-icon.svg";
import { ReactComponent as HearthIcon } from "../../../assets/images/icons/hearth-icon.svg";
import { ReactComponent as PregnantWomanIcon } from "../../../assets/images/icons/pregnant-woman-icon.svg";
import { ReactComponent as FinancialIcon } from "../../../assets/images/icons/financial-icon.svg";

export const healthInsuranceList = [
  {
    id: 1,
    icon: MedicalAdviceIcon,
    title: "Aconselhamento médico",
    description:
      "A Central de Saúde disponibiliza para você acesso direto a equipe médica e administrativa para apoio nas tomadas de decisões e esclarecimento de dúvidas médicas.",
  },
  {
    id: 2,
    icon: HearthIcon,
    title: "Acompanhamento de internações",
    description: (
      <>
        O acompanhamento agiliza e facilita os passos técnicos, melhora o
        processo de internação e procedimentos especiais para atender às
        necessidades do paciente e de sua família.
      </>
    ),
  },
  {
    id: 3,
    icon: PregnantWomanIcon,
    title: "Cuidado com a gravidez e o bebê",
    description: (
      <>
        A Central de Saúde acompanha a gravidez, o desenvolvimento do feto e
        ajuda a futura mamãe com todos os cuidados necessários. Além disso, após
        o parto, acompanhamos o desenvolvimento e o crescimento do bebê - do
        momento que nasce até completar 12 meses.
      </>
    ),
  },
  {
    id: 4,
    icon: FinancialIcon,
    title: "Gestão facilitada",
    description: (
      <>
        A gestão do seguro é totalmente informatizada, com acesso 24 horas,
        todos os dias da semana, incluindo procedimentos online para liberação
        de exames.
      </>
    ),
  },
];

export const readjustmentList = [
  {
    id: 1,
    label:
      "Percentual de reajuste dos contratos - Entre maio de 2025 a abril de 2026",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-maio-de-2025-a-abril-de-2026.pdf",
  },
  {
    id: 2,
    label:
      "Percentual de reajuste dos contratos - Entre maio de 2024 a abril de 2025",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-maio-de-2024-a-abril-de-2025.pdf",
  },
  {
    id: 3,
    label:
      "Percentual de reajuste dos contratos - Entre maio de 2023 a abril de 2024",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-maio-de-2023-a-abril-de-2024.pdf",
  },
  {
    id: 4,
    label:
      "Percentual de reajuste dos contratos - Entre maio de 2022 a abril de 2023",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-maio-de-2022-a-abril-de-2023.pdf",
  },
  {
    id: 5,
    label:
      "Percentual de reajuste dos contratos - Entre maio de 2021 a abril de 2022",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-maio-de-2021-a-abril-de-2022.pdf",
  },
  {
    id: 6,
    label:
      "Percentual de reajuste dos contratos - Entre maio de 2020 a abril de 2021",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-maio-de-2020-a-abril-de-2021.pdf",
  },
  {
    id: 7,
    label:
      "Percentual de reajuste dos contratos - Entre maio de 2019 a abril de 2020",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-maio-de-2019-a-abril-2020.pdf",
  },
  {
    id: 8,
    label:
      "Percentual de reajuste dos contratos - Entre maio de 2018 a abril de 2019",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-maio-de-2018-a-abril-de-2019.pdf",
  },
  {
    id: 9,
    label:
      "Percentual de reajuste dos contratos - Entre maio de 2017 a abril de 2018",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-maio-de-2017-a-abril-de-2018.pdf",
  },
  {
    id: 10,
    label:
      "Percentual de reajuste dos contratos - Entre maio de 2016 a abril de 2017",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-maio-de-2016-a-abril-de-2017.pdf",
  },
  {
    id: 11,
    label:
      "Percentual de reajuste dos contratos - Entre maio de 2015 a abril de 2016",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-maio-de-2015-a-abril-de-2016.pdf",
  },
  {
    id: 12,
    label:
      "Percentual de reajuste dos contratos - Entre junho de 2013 a abril de 2014",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/percentual-de-reajuste-dos-contratos-junho-de-2013-a-abril-de-2014.pdf",
  },
];

export const generalConditionsList = [
  {
    id: 1,
    label: "Produtos ambulatorial + Hospitalar com obstetrícia - pré pagamento",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/produtos_ambulatorial_e_hospitalar_com_obstetricia_pre_pagamento.pdf",
  },
  {
    id: 2,
    label: "Produtos ambulatorial + Hospitalar sem obstetrícia - pré pagamento",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/produtos_ambulatorial_e_hospitalar_sem_obstetricia_pre_pagamento.pdf",
  },
];

export const pregnantWomanList = [
  {
    id: 1,
    label: "Cartão da Gestante",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/cartao_gestante.pdf",
  },
  {
    id: 2,
    label: "Nota de orientação à gestante",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/RN_398_anexo_nota_de_orientacao_a_gestante.pdf",
  },
  {
    id: 3,
    label: "Resolução Normativa - RN Nº 389, de 26 de novembro de 2015",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/ANS_RN_389_26nov2015.pdf",
  },
];

const financialInformationLabel =
  "Demonstrações Financeiras e Relatório da Administração - Caixa Seguradora Saúde";

export const financialInformationList = [
  {
    id: 1,
    title: "2024",
    links: [
      {
        id: "1-link",
        label: financialInformationLabel,
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/saude-dfs-dez-2024-completa.pdf",
      },
    ],
  },
  {
    id: 2,
    title: "2023",
    links: [
      {
        id: "2-link",
        label: financialInformationLabel,
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/saude-dfs-dez-2023-completa.pdf",
      },
    ],
  },
  {
    id: 3,
    title: "2022",
    links: [
      {
        id: "2-link",
        label: financialInformationLabel,
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/saude-dfs-dez-2022-completa.pdf",
      },
    ],
  },
  {
    id: 4,
    title: "2021",
    links: [
      {
        id: "4-link",
        label: financialInformationLabel,
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/saude-dfs-dez-2021-completa.pdf",
      },
    ],
  },
  {
    id: 5,
    title: "2020",
    links: [
      {
        id: "5-link",
        label: "Demonstração Financeiras Caixa Seguradora Saúde",
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/saude-dfs-dez-2020-completa.pdf",
      },
      {
        id: "5-1-link",
        label: "Relatório da Administração ",
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/relatorio-da-administração-0502021.pdf",
      },
    ],
  },
  {
    id: 6,
    title: "2019",
    links: [
      {
        id: "6-link",
        label: "Relatório do Auditor Independente",
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/saude-dfs-dez-2019-final.pdf",
      },
      {
        id: "6-1-link",
        label: financialInformationLabel,
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/saude-dfs-dez-2019-final-interno.pdf",
      },
      {
        id: "6-1-link",
        label: "Relatório da Administração",
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/relatorio-da-administracao-13022020.pdf",
      },
    ],
  },
  {
    id: 7,
    title: "2018",
    links: [
      {
        id: "6-link",
        label: "Relatório do Auditor Independente",
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/saude-dfs-dez-2018-final.pdf",
      },
      {
        id: "6-1-link",
        label: financialInformationLabel,
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/Saude/saude-dfs-dez-2018-final-interno.pdf",
      },
    ],
  },
];
